/* Sydney Timber Supply - lead source attribution (C12, 2026-08-09).

   Captures where a visitor came from so that enquiry/quote/trade form
   submissions carry their traffic source. First-party only: nothing is sent
   anywhere except inside the visitor's own form submission.

   - First touch: stored once in localStorage on the first page of the first
     visit (UTM params, click IDs, landing path, referrer, timestamp).
   - Last touch: refreshed in sessionStorage whenever a new session starts or
     new campaign parameters arrive.
   - Forms: hidden inputs marked data-sts-attr are filled before submit;
     inputs still empty at submit time are removed so notification emails
     stay clean.

   No personal data is collected here - only URL parameters, the landing
   path, the referring URL and a derived source label. */
(function () {
  'use strict';

  var FIRST_KEY = 'sts_attr_first';
  var LAST_KEY = 'sts_attr_last';
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];

  function safeGet(storage, key) {
    try { return JSON.parse(storage.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function safeSet(storage, key, value) {
    try { storage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ }
  }

  function readParams() {
    var qs = new URLSearchParams(window.location.search);
    var out = {};
    var any = false;
    PARAMS.forEach(function (p) {
      var v = qs.get(p);
      if (v) { out[p] = v.slice(0, 200); any = true; }
    });
    return any ? out : null;
  }

  function externalReferrer() {
    var ref = document.referrer || '';
    if (!ref) return '';
    try {
      if (new URL(ref).host === window.location.host) return '';
    } catch (e) { return ''; }
    return ref.slice(0, 300);
  }

  /* A human-readable summary so a lead email answers "where from?" at a
     glance, without anyone decoding UTMs. */
  function deriveSource(rec) {
    if (!rec) return 'Direct';
    if (rec.gclid) return 'Google Ads (gclid)';
    if (rec.fbclid) return 'Facebook / Instagram (fbclid)';
    if (rec.utm_source) {
      var s = rec.utm_source + (rec.utm_medium ? ' / ' + rec.utm_medium : '');
      return 'Campaign: ' + s + (rec.utm_campaign ? ' / ' + rec.utm_campaign : '');
    }
    if (rec.referrer) {
      var host = '';
      try { host = new URL(rec.referrer).host; } catch (e) { /* ignore */ }
      if (/google\./i.test(host)) return 'Organic Google';
      if (/bing\./i.test(host)) return 'Organic Bing';
      if (/facebook\.|instagram\./i.test(host)) return 'Facebook / Instagram (organic)';
      return host ? 'Referral: ' + host : 'Direct';
    }
    return 'Direct';
  }

  function capture() {
    var params = readParams();
    var now = new Date().toISOString();

    var first = safeGet(window.localStorage, FIRST_KEY);
    if (!first) {
      first = params || {};
      first.landing = (window.location.pathname + window.location.search).slice(0, 300);
      first.referrer = externalReferrer();
      first.ts = now;
      safeSet(window.localStorage, FIRST_KEY, first);
    }

    var last = safeGet(window.sessionStorage, LAST_KEY);
    if (!last || params) {
      last = params || {};
      last.landing = (window.location.pathname + window.location.search).slice(0, 300);
      last.referrer = externalReferrer();
      last.ts = now;
      safeSet(window.sessionStorage, LAST_KEY, last);
    }
  }

  function fillForms() {
    var first = safeGet(window.localStorage, FIRST_KEY) || {};
    var last = safeGet(window.sessionStorage, LAST_KEY) || {};
    var merged = {
      source_summary: deriveSource(Object.keys(last).length > 1 || last.utm_source || last.gclid || last.fbclid ? last : first),
      utm_source: last.utm_source || first.utm_source || '',
      utm_medium: last.utm_medium || first.utm_medium || '',
      utm_campaign: last.utm_campaign || first.utm_campaign || '',
      utm_content: last.utm_content || first.utm_content || '',
      utm_term: last.utm_term || first.utm_term || '',
      gclid: last.gclid || first.gclid || '',
      fbclid: last.fbclid || first.fbclid || '',
      landing: first.landing || '',
      referrer: first.referrer || last.referrer || '',
      first_seen: first.ts || ''
    };

    document.querySelectorAll('input[data-sts-attr]').forEach(function (input) {
      var key = input.getAttribute('data-sts-attr');
      if (Object.prototype.hasOwnProperty.call(merged, key)) {
        input.value = merged[key];
      }
    });

    /* Keep notification emails clean: drop hidden attribution inputs that
       are still empty when the form is actually submitted. */
    document.querySelectorAll('form').forEach(function (form) {
      if (!form.querySelector('input[data-sts-attr]')) return;
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[data-sts-attr]').forEach(function (input) {
          if (!input.value) input.remove();
        });
      });
    });
  }

  capture();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillForms);
  } else {
    fillForms();
  }
})();
